import axios from "axios";
import apis from './index'

export const employeeCreateApi = async (formdata) => {
  const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
  
  try {
    const response = await axios.post(
      apis.employee.createEmployee,
      formdata,  // Send the FormData object
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Set the correct content type for multipart
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error creating employee:", error);
    throw error;
  }
};


export const getEmployeesApi = async (currentPage,sort,sortValue,searchInputValue) => {
    const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
    try {
        const response = await axios.get(`${apis.employee.employeeList}?page=${currentPage}&limit=${sort}&sort=${sortValue?.value ? `${sortValue?.value}:`: ""}${sortValue?.type ? sortValue?.type : ""}&search=${searchInputValue}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error creating facility:", error);
    throw error;
  }
};

export const deleteEmployeApi = async (id) => {
  const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
  try {
      const response = await axios.delete(`${apis.employee.deleteEmployee}/${id}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
} catch (error) {
  console.error("Error creating facility:", error);
  throw error;
}
};

export const GetEditEmployeeDataApi = async (id) => {
  const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
  try {
      const response = await axios.get(`${apis.employee.getEmployeeById}/${id}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
} catch (error) {
  console.error("Error creating facility:", error);
  throw error;
}
};

export const editEmployeeApi = async (id,formData) => {
  const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
  try {
      const response = await axios.patch(`${apis.employee.editEmployee}/${id}`,
        formData,
    {
      headers: {
        // 'Content-Type': 'application/json',
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
} catch (error) {
  console.error("Error creating facility:", error);
  throw error;
}
};

// admin Frogogt pass
export const employeeResetPasswordApi = async (formData) => {
  const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
  // console.log("handleUserLogin", formData)
  try {
      const response = await axios.post(
          apis.employee.resetEmployeePassword,
          formData,
    {
      headers: {
        'Content-Type': 'application/json',
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
} catch (error) {
  console.error("Error creating facility:", error);
  throw error;
}
};

export const UpdateEmployeeStatus = async (id,formData) => {
  const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
  try {
    const response = await axios.patch(
      `${apis.employee.updateEmployeeStatus}/${id}`,formData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error creating facility:", error);
    throw error;
  }
};

export const employeeChangePasswordApi = async (formData) => {
  const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
  // console.log("handleUserLogin", formData)
  try {
      const response = await axios.post(
          apis.employee.employeeChangePassword,
          formData,
    {
      headers: {
        'Content-Type': 'application/json',
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
} catch (error) {
  console.error("Error creating facility:", error);
  throw error;
}
};



// export const UpdateRoleApi = async (id,formData) => {
//   const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
//   try {
//       const response = await axios.patch(`${apis.roles.updateRole}/${id}`,
//         formData,
//     {
//       headers: {
//         'Content-Type': 'application/json',
//         // "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${token}`,
//       },
//     }
//   );
//   return response;
// } catch (error) {
//   console.error("Error creating facility:", error);
//   throw error;
// }
// };
